import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext} from 'react'
import {NullAsDefault, renderIf} from 'views/Shared'
import _ from "lodash"
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {WrapperFilterItem} from "../../custom/FilterBar";
import {SelectCountries} from "../../../Organization/Settings/SelectCountries";
import {useAppConfig} from "../../../../modules/local/AppConfigContext";
import {FilterStatusBar} from "../../../../components/Filters/FilterStatusBar";
import LookupField from "../../../../components/LookupField";
import {Avatar} from "antd";
import {MdChurch} from "react-icons/md";
import {RiMapPinFill} from "react-icons/ri";

const defaultFilter = {
  keyword: undefined,
    country_id: undefined,
    archdiocese_id: undefined,
    diocese_id: undefined,
    deanery_id: undefined,
}
const labels = {
  archdiocese_id: 'archdiocese',
  diocese_id: 'diocese',
  deanery_id: 'deanery',
};

export const ParishFilter = ({
                               value: filter = defaultFilter,
                               onChange: setValues = NullAsDefault,
                               ...props
                             }) => {
  const t = useTranslate()
  const {isSm} = useContext(LayoutContext)
  const {countries = [], archdioceses = [], dioceses = [], deaneries = []} = useAppConfig('countries', 'archdioceses', 'dioceses', 'deaneries')

  const handleChange = useCallback(
    (name, value) => {
      setValues({
        ...filter,
        [name]: value,
      })
    },
    [filter]
  )

  const filteredParams = Object.entries(filter).filter(([key, value]) => {
    switch (key) {
      case "diocese":
      case "diocese_name":
        // các key này chỉ để lưu kèm dữ liệu, không tự tạo chip riêng
        // (đã được thể hiện qua chip "diocese_id" bên dưới)
        return false;
      case "archdiocese_id":
      case "diocese_id":
      case "deanery_id":
      default:
        return value !== undefined && value !== null;
    }
  }).map(([key, value]) => {
    switch (key) {
      case "country_id":
        const country = _.find(countries, {id: Number(value)})?.common_name
        return {
          key,
          value,
          displayValue: t(country),
        }
      case "archdiocese_id":
        const archdiocese = _.find(archdioceses, {archdiocese_id: value})?.fullname
        return {
          key,
          value,
          displayValue: t(archdiocese),
        }
      case "diocese_id":
        // ưu tiên diocese_name đã có sẵn từ LookupField (kể cả khi diocese
        // không nằm trong list preload `dioceses`), fallback tra trong list
        const diocese = filter.diocese_name || _.find(dioceses, {id: value})?.fullname
        return {
          key,
          value,
          displayValue: t(diocese),
        }
      case "deanery_id":
        const deanery = _.find(deaneries, {id: value})?.fullname
        return {
          key,
          value,
          displayValue: t(deanery),
        }
      default:
        return {
          key,
          value,
          displayValue: value,
          label: labels[key] || key,
        }
    }
  });

  return (
    <div key={JSON.stringify(filter)} className="flex flex-col gap-3">

      <FilterStatusBar
          filteredParams={filteredParams}
          onClear={() => {
              setValues(defaultFilter)
          }}
          onRemove={(param) => {
              handleChange(param, undefined)
          }}
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <WrapperFilterItem label="country" className="col-span-1">
              <SelectCountries
                  value={!!filter?.country_id ? filter?.country_id : undefined}
                  onChange={(value) => {
                      handleChange("country_id", Number(value) ?? null)
                  }}
                  placeholder={t('click to select')}
              />
          </WrapperFilterItem>
          <WrapperFilterItem label="diocese" showPrefix={!isSm}>

              <LookupField
                  title={t('choose diocese')}
                  placeholder={t('click to select')}
                  createIfNotExists={false}
                  defaultValue={_.find(filteredParams, {key: 'diocese_id'})?.displayValue}
                  selectedOption={_.find(filteredParams, {key: 'diocese_id'})?.diocese}
                  apiPath={`/lookup/diocese/get-by-types`}
                  OptionWrapper={({children, ...props}) =>
                      <div
                          className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative" {...props}>
                          {children}
                      </div>
                  }
                  renderOption={(o, i) => {
                      const {fullname, location_address} = o ?? {}
                      return (
                          <div key={i} className="flex items-center flex-1 gap-3">
                              <Avatar
                                  size={50}
                                  src={o.avatar}
                                  className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                                  icon={<MdChurch size={20} style={{color: '#dddddd'}}/>}
                              />
                              <div className="py-2 md:py-0 flex flex-col flex-1 min-w-0 gap-1">
                                  <div className="space-x-1 leading-snug">
                                                                      <span
                                                                          className="font-bold text-sm text-color-000">
                                                                          {fullname}
                                                                      </span>
                                  </div>
                                  {renderIf(
                                      location_address,
                                      <div className="flex items-center gap-x-1">
                                          <RiMapPinFill size={11} className="text-color-400"/>
                                          <span
                                              className="flex-1 max-lines-1 text-xs text-color-400 italic leading-snug">
                                                                            {location_address}
                                                                          </span>
                                      </div>
                                  )}
                              </div>
                          </div>
                      )
                  }}
                  handleChange={(e) => {
                      setValues({
                          ...filter,
                          diocese: e.target,
                          diocese_id: e.target.id,
                          diocese_name: e.target.name
                      })
                  }}
              />
          </WrapperFilterItem>
      </div>

      <div className="h-3"/>

    </div>
  )
}

export default ParishFilter
